import store from '@/store';
import { isString } from 'lodash';

export default function(d: Date|string, format: string): string {
    let datestring: string = '';
    if (isString(d)) {
        d = new Date(d);
    }
    switch (format) {
        case 'Y-m-d':
            datestring = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2)
                + '-' + ('0' + d.getDate()).slice(-2);
            break;
        case 'Y-m-d h:i:s':
            datestring = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2)
                + '-' + ('0' + d.getDate()).slice(-2) + ' '
                + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
                + ':' + ('0' + d.getSeconds()).slice(-2);
            break;
        case 'config':
            const year = d.getFullYear();
            const month = d.getMonth() + 1;
            const day =  d.getDate();

            // vedi node_modules/vuejs-datepicker/src/utils/DateUtils.js
            datestring = store.state.options.dateFormat
                .replace(/dd/, ('0' + day).slice(-2))
                .replace(/d/, day)
                .replace(/yyyy/, year)
                .replace(/yy/, String(year).slice(2))
                .replace(/MM/, ('0' + month).slice(-2))
                .replace(/M(?!a|ä|e)/, month);
            break;
        default:
            throw new Error('Date format not valid for the filter');
    }

    return datestring;
}
